module.exports = __webpack_public_path__ + "static/media/tokenomics-bg.02efff28.png";